<script>
import { mapState, mapActions } from 'vuex'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import { VueGoodTable } from 'vue-good-table'
import { SweetModal } from 'sweet-modal-vue'
import VuePdfApp from 'vue-pdf-app'
import { debounce } from 'vue-debounce'
import { id } from 'vuejs-datepicker/dist/locale'
import vSelect from 'vue-select'
import PaginationCustom from '@/components/table/Pagination.vue'
import appData from '@/data'
import kodeDaerah from '@/data/modules/kodeDaerah'

export default {
   name: 'OssNib',
   components: {
      BCardCode,
      VueGoodTable,
      PaginationCustom,
      SweetModal,
      VuePdfApp,
      vSelect,
   },
   data() {
      return {
         pdf: '',
         loadingPdf: false,
         loading: true,
         filterDateLang: id,
         serverParams: {
            columnFilters: {},
            sort: {
               field: '',
               type: '',
            },
            search: '',
            page: 1,
            perPage: 10,
            filter: {
               tanggal_awal: null,
               tanggal_akhir: null,
               // jenis: null,
               kd_skala_usaha_final: null,
               jenis_perusahaan: null,
               status_penanaman_modal: null,
               perusahaan_daerah_id: null,
               daerah_mode: 'kecamatan',
            },
         },
         pageLength: 10,
         pageOptions: ['10', '25', '50', '100'],
         searchTerm: '',
         isFilterOpen: false,
         columns: [
            {
               label: 'Nama / NIB',
               field: 'nib',
               sortable: false,
               thClass: 'text-center align-middle',
            },
            {
               label: 'Nama PJ',
               field: 'nama_pj',
               sortable: false,
               thClass: 'text-center align-middle',
            },
            {
               label: 'Skala / Jenis / Status',
               field: 'kd_skala_usaha_final',
               sortable: false,
               thClass: 'text-center align-middle',
            },
            {
               label: 'Tanggal',
               field: 'tanggal_terbit_oss',
               sortable: false,
               thClass: 'text-center align-middle',
            },
            {
               label: 'Alamat',
               field: 'alamat_perusahaan',
               sortable: false,
               thClass: 'text-center align-middle',
            },
            {
               label: 'KBLI',
               field: 'kbli',
               sortable: false,
               thClass: 'text-center align-middle',
            },
            {
               label: 'Status',
               field: 'status_nib',
               sortable: false,
               thClass: 'text-center align-middle',
            },
            {
               label: 'Action',
               field: 'action',
               sortable: false,
               thClass: 'text-center align-middle',
            },
         ],

      }
   },
   computed: {
      ...mapState({
         myData: state => state.OssNib.items,
         myCount: state => state.OssNib.countAll,
      }),
      jenisPerusahaan() {
         const data = appData.jenisPerusahaan
         return status => (data[status] ? data[status] : status)
      },
      skalaUsaha() {
         const data = appData.skalaUsaha
         return status => (data[status] ? data[status] : status)
      },
      statusPM() {
         const data = appData.statusPm
         return status => (data[status] ? data[status] : status)
      },
      statusResiko() {
         const data = appData.statusResiko
         return status => (data[status] ? data[status] : '-')
      },
      statusNIB() {
         const data = appData.statusNib
         return status => (data[status] ? data[status] : status)
      },
      statusBadanHukum() {
         const data = appData.statusBadanHukum
         return status => (data[status] ? data[status] : status)
      },
      optionsSkalaUsaha() {
         return Object.entries(appData.skalaUsaha).map(([value, text]) => ({ value, text }))
      },
      optionsJenisPerusahaan() {
         return Object.entries(appData.jenisPerusahaan).map(([value, text]) => ({ value, text }))
      },
      optionsStatusPM() {
         return Object.entries(appData.statusPm).map(([value, text]) => ({ value, text }))
      },
      optionsDaerah() {
         return kodeDaerah.map(item => ({
            value: item.kode,
            text: `${item.kode} - ${item.kecamatan} - ${item.kelurahan}`,
         }))
      },
      statusNIBVariant() {
         const data = {
            /* eslint-disable key-spacing */
            '01': 'success',
            '06': 'danger',
            /* eslint-enable key-spacing */
         }
         return status => (data[status] ? data[status] : 'primary')
      },
   },
   watch: {
      loadingPdf(val) {
         if (val) {
            this.$swal({ text: 'Loading', allowOutsideClick: false })
            this.$swal.showLoading()
         } else {
            this.$swal.close()
         }
      },
   },
   mounted() {
      this.loadItems()
   },
   methods: {
      ...mapActions({
         getData: 'OssNib/getData',
         cetakNib: 'OssNib/cetakNib',
         cetakListNib: 'OssNib/cetakListNib',
      }),
      onDetailNib(idPermohonan) {
         this.$router.push(`/oss/nib/${idPermohonan}`)
      },
      onCetakNib(nib) {
         this.loadingPdf = true
         this.cetakNib(nib).then(res => {
            const blob = new Blob([res.data])
            this.pdf = URL.createObjectURL(blob)
            // URL.revokeObjectURL(objectURL)
            this.$refs.modalPdf.open()
            this.loadingPdf = false
         }, () => {
            this.loadingPdf = false
         })
      },
      onCetak() {
         if (!this.isFilterOpen) {
            this.$toast.error('Aktifkan filter untuk mencetak PDF')
            return
         }
         this.loadingPdf = true
         const params = {}
         const tglAwal = this.formatDate(this.serverParams.filter.tanggal_awal)
         const tglAkhir = this.formatDate(this.serverParams.filter.tanggal_akhir)
         if (tglAwal) params.tanggal_awal = tglAwal
         if (tglAkhir) params.tanggal_akhir = tglAkhir
         if (this.serverParams.filter.kd_skala_usaha_final !== null) {
            params.kd_skala_usaha_final = this.serverParams.filter.kd_skala_usaha_final
         }
         if (this.serverParams.filter.jenis_perusahaan !== null) {
            params.jenis_perusahaan = this.serverParams.filter.jenis_perusahaan
         }
         if (this.serverParams.filter.status_penanaman_modal !== null) {
            params.status_penanaman_modal = this.serverParams.filter.status_penanaman_modal
         }
         if (this.serverParams.filter.perusahaan_daerah_id !== null) {
            params.perusahaan_daerah_id = this.serverParams.filter.perusahaan_daerah_id
            params.daerah_mode = this.serverParams.filter.daerah_mode
         }
         if (this.searchTerm) {
            params.search = this.searchTerm
         }
         this.cetakListNib(params).then(res => {
            const blob = new Blob([res.data])
            this.pdf = URL.createObjectURL(blob)
            this.$refs.modalPdf.open()
            this.loadingPdf = false
         }, () => {
            this.loadingPdf = false
         })
      },
      formatDate(date) {
         if (!date) return null
         const d = new Date(date)
         const year = d.getFullYear()
         const month = String(d.getMonth() + 1).padStart(2, '0')
         const day = String(d.getDate()).padStart(2, '0')
         return `${year}-${month}-${day}`
      },
      onFilter() {
         this.serverParams.page = 1
         setTimeout(() => {
            this.loadItems()
         }, 100)
      },

      // VUE GOOD TABLE
      loadItems() {
         this.loading = true
         this.getData(this.serverParams)
      },
      updateParams(newProps) {
         // eslint-disable-next-line prefer-object-spread
         this.serverParams = Object.assign({}, this.serverParams, newProps)
      },
      onPageChangePagination(page) {
         this.updateParams({ page })
         this.loadItems()
      },
      onPerPageChangePagination(perPage) {
         this.updateParams({ perPage, page: 1 })
         this.loadItems()
      },
      onColumnFilter(params) {
         this.updateParams({ ...params, page: 1 })
         this.loadItems()
      },
      onSearch: debounce(function search(params) {
         this.serverParams.search = params
         this.serverParams.page = 1
         this.loadItems()
      }, 500),
      onShownCollapse() {
         // console.log('Collapse is now fully visible.')
         this.isFilterOpen = true
         this.serverParams.page = 1
         this.serverParams.filter.tanggal_awal = new Date(new Date().getFullYear(), 0, 1)
         this.serverParams.filter.tanggal_akhir = new Date()
         // this.serverParams.filter.jenis = null
         this.loadItems()
      },
      onHiddenCollapse() {
         this.isFilterOpen = false
         this.serverParams.page = 1
         this.serverParams.filter.tanggal_awal = null
         this.serverParams.filter.tanggal_akhir = null
         // this.serverParams.filter.jenis = null
         this.serverParams.filter.kd_skala_usaha_final = null
         this.serverParams.filter.jenis_perusahaan = null
         this.serverParams.filter.status_penanaman_modal = null
         this.serverParams.filter.perusahaan_daerah_id = null
         this.serverParams.filter.daerah_mode = 'kecamatan'
         this.loadItems()
      },
   },
}
</script>

<template>
   <div>
      <b-card-code title="Data NIB">
         <!-- search input -->
         <b-row>
            <!-- TOOLBAR -->
            <b-col cols="12" md="6">
               <b-form @submit.stop.prevent>
                  <div class="d-flex align-items-center justify-content-end">
                     <b-form-input
                        v-model="searchTerm"
                        class="d-inline-block mb-1"
                        placeholder="Search..."
                        autocomplete="off"
                        type="text"
                        aria-label="Search"
                        @input="onSearch"
                     />
                  </div>
               </b-form>
            </b-col>
            <b-col cols="12" md="6">
               <div class="d-flex justify-content-end">
                  <b-button-group class="mb-1">
                     <b-button
                        v-b-tooltip.hover.top="'Filter'"
                        v-b-toggle.collapse-filter
                        variant="outline-secondary"
                        size="sm"
                     >
                        <feather-icon icon="FilterIcon" />
                     </b-button>
                     <b-button
                        v-b-tooltip.hover.top="'Cetak PDF'"
                        variant="outline-secondary"
                        size="sm"
                        @click="onCetak()"
                     >
                        <feather-icon icon="FileTextIcon" />
                     </b-button>
                     <b-button variant="outline-secondary" size="sm" @click="loadItems()">
                        <feather-icon icon="RefreshCwIcon" />
                     </b-button>
                     <b-dropdown variant="outline-secondary" right text="Menu" size="sm">
                        <b-dropdown-item @click="onCetak()">
                           Cetak PDF
                        </b-dropdown-item>
                        <b-dropdown-item @click="loadItems()">
                           Refresh
                        </b-dropdown-item>
                     </b-dropdown>
                  </b-button-group>
               </div>
            </b-col>

            <!-- FILTER -->
            <b-col>
               <b-collapse id="collapse-filter" class="mt-2" @shown="onShownCollapse" @hidden="onHiddenCollapse">
                  <b-card class="border">
                     <b-row>
                        <b-col md="4">
                           <b-form-group label="Tanggal Terbit Awal" label-for="tahun">
                              <datepicker
                                 v-model="serverParams.filter.tanggal_awal"
                                 input-class="datepicker-here form-control "
                                 minimum-view="date"
                                 maximum-view="year"
                                 format="dd MMMM yyyy"
                                 :language="filterDateLang"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>
                        <b-col md="4">
                           <b-form-group label="Tanggal Terbit Akhir" label-for="tahun">
                              <datepicker
                                 v-model="serverParams.filter.tanggal_akhir"
                                 input-class="datepicker-here form-control "
                                 minimum-view="date"
                                 maximum-view="year"
                                 format="dd MMMM yyyy"
                                 :language="filterDateLang"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>
                        <!-- <b-col md="4">
                           <b-form-group label="Jenis Permohonan" label-for="Jenis Permohonan">
                              <b-form-select v-model="serverParams.filter.jenis" :options="options.jenis" @input="onFilter" />
                           </b-form-group>
                        </b-col> -->
                     </b-row>

                     <b-row class="mt-2">
                        <b-col md="3">
                           <b-form-group label="Skala Perusahaan" label-for="skala-usaha">
                              <v-select
                                 id="skala-usaha"
                                 v-model="serverParams.filter.kd_skala_usaha_final"
                                 :options="optionsSkalaUsaha"
                                 :reduce="opt => opt.value"
                                 label="text"
                                 placeholder="Pilih Skala..."
                                 :clearable="true"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>
                        <b-col md="3">
                           <b-form-group label="Jenis Perusahaan" label-for="jenis-perusahaan">
                              <v-select
                                 id="jenis-perusahaan"
                                 v-model="serverParams.filter.jenis_perusahaan"
                                 :options="optionsJenisPerusahaan"
                                 :reduce="opt => opt.value"
                                 label="text"
                                 placeholder="Pilih Jenis..."
                                 :clearable="true"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>
                        <b-col md="3">
                           <b-form-group label="Status Penanaman Modal" label-for="status-pm">
                              <v-select
                                 id="status-pm"
                                 v-model="serverParams.filter.status_penanaman_modal"
                                 :options="optionsStatusPM"
                                 :reduce="opt => opt.value"
                                 label="text"
                                 placeholder="Pilih Status PM..."
                                 :clearable="true"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>
                        <b-col md="3">
                           <b-form-group label="Daerah" label-for="daerah">
                              <b-form-radio-group
                                 id="daerah-mode"
                                 v-model="serverParams.filter.daerah_mode"
                                 :options="[{ text: 'Kecamatan', value: 'kecamatan' }, { text: 'Kelurahan/Desa', value: 'kelurahan' }]"
                                 class="mb-1"
                                 @change="serverParams.filter.perusahaan_daerah_id = null; onFilter()"
                              />
                              <v-select
                                 id="daerah"
                                 v-model="serverParams.filter.perusahaan_daerah_id"
                                 :options="optionsDaerah"
                                 :reduce="opt => opt.value"
                                 label="text"
                                 placeholder="Pilih Daerah..."
                                 :clearable="true"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>
                     </b-row>
                  </b-card>
               </b-collapse>
            </b-col>
            <!-- FILTER -->
         </b-row>

         <!-- table -->
         <vue-good-table
            ref="goodTable"
            mode="remote"
            :columns="columns"
            :rows="myData"
            :total-rows="myCount"
            :is-loading.sync="loading"
            :line-numbers="true"
            :pagination-options="{
               enabled: true,
               mode: 'pages',
            }"
            :search-options="{
               enabled: true,
               externalQuery: searchTerm,
            }"
            @on-column-filter="onColumnFilter"
            @on-search="onSearch"
         >
            <template slot="table-row" slot-scope="props">
               <!-- Column: Name -->
               <span v-if="props.column.field == 'nib'">
                  <b>{{ (props.row.nama_perusahaan) }}</b>
                  <br>
                  <hr>
                  <b class="text-primary">{{ (props.row.nib) }}</b>
                  <br>
                  <small>Telp. {{ props.row.nomor_telp_perusahaan || '-' }}</small>
               </span>

               <span v-if="props.column.field == 'nama_pj'">
                  <b>{{ props.row.nama_pj }}</b>
                  <br>
                  <small>Telp. {{ props.row.telp_pj || '-' }}</small>
               </span>

               <span v-if="props.column.field == 'kbli'">
                  <center>{{ props.row.totalKbli }}</center>
               </span>

               <span v-if="props.column.field == 'alamat_perusahaan'">
                  <small>{{ (props.row.alamat_perusahaan) }}</small>
                  <br>
                  <small v-if="props.row.kecamatan">
                     Desa/kel:
                     <b>{{ props.row.kelurahan }}</b>
                     <br>Kec:
                     <b>{{ props.row.kecamatan }}</b>
                  </small>
               </span>

               <span v-else-if="props.column.field == 'status_nib'">
                  <center>
                     <b-badge :variant="statusNIBVariant(props.row.status_nib)" class="text-white">
                        <small>{{ statusNIB(props.row.status_nib) }}</small>
                     </b-badge>
                  </center>
               </span>

               <span v-if="props.column.field == 'kd_skala_usaha_final'">
                  Skala : {{ skalaUsaha(props.row.kd_skala_usaha_final) }}
                  <br>
                  <hr>
                  <small>{{ statusBadanHukum(props.row.status_badan_hukum) }}</small>
                  <br>
                  <hr>
                  <small>{{ jenisPerusahaan(props.row.jenis_perusahaan) }}</small>
                  <br>
                  <hr>
                  <small>{{ statusPM(props.row.status_penanaman_modal) }}</small>
               </span>

               <span v-if="props.column.field == 'tanggal_terbit_oss'">
                  <table class="borderless">
                     <tr>
                        <td>Terbit</td>
                        <td>&nbsp;:&nbsp;</td>
                        <td
                           class="nowrap"
                        >{{ (props.row.tanggal_terbit_oss) | moment("DD-MM-YYYY") }}</td>
                     </tr>
                     <tr>
                        <td>Perubahan</td>
                        <td>&nbsp;:&nbsp;</td>
                        <td
                           class="nowrap"
                        >{{ (props.row.tanggal_perubahan_nib) | moment("DD-MM-YYYY") }}</td>
                     </tr>
                  </table>
               </span>

               <span v-if="props.column.field == 'action'">
                  <b-link
                     class="btn btn-outline-dark btn-sm btn-block"
                     :to="`/oss/nib/${props.row.id_permohonan}`"
                  ><small>Detail</small></b-link>
                  <b-button
                     v-b-tooltip.hover.top="'Cetak NIB'"
                     size="sm"
                     block
                     variant="primary"
                     :disabled="!props.row.s3_path"
                     class="nowrap"
                     @click="onCetakNib(props.row.nib)"
                  >
                     <feather-icon icon="FileTextIcon" class="mr-50" />
                     <small>NIB</small>
                  </b-button>
               </span>
               <!-- Column: Common -->
               <!-- <span v-else>{{ props.formattedRow[props.column.field] }}</span> -->
               <!-- <span v-else>{{ props.formattedRow[props.column.field] }}</span> -->
            </template>

            <!-- pagination -->
            <template slot="pagination-bottom" slot-scope="props">
               <pagination-custom
                  :total="props.total"
                  :page-length="pageLength"
                  :page-options="pageOptions"
                  :page="serverParams.page"
                  :page-changed="props.pageChanged"
                  :per-page-changed="props.perPageChanged"
                  @update:page="onPageChangePagination"
                  @update:perpage="onPerPageChangePagination"
               />
            </template>
         </vue-good-table>
      </b-card-code>

      <sweet-modal ref="modalPdf" modal-theme="light" overlay-theme="dark" width="80%">
         <!-- <pdf :src="pdf" /> -->
         <div style="height: 70vh;">
            <vue-pdf-app :pdf="pdf" />
         </div>
      </sweet-modal>
   </div>
</template>

<style scoped>
.borderless > tr > td {
   border: none;
   padding: 0em;
}
table > tbody > tr > td > span > hr {
   margin-top: 0rem;
   margin-bottom: 0rem;
}

.nowrap {
   white-space: nowrap;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
